import { groupBys } from '@/utils/columnSearch';
import request from '@aned/request';

// import request from '@/components/request';

export async function fakeAccountLogin(params) {
  return request('api/access/login', {
    method: 'POST',
    body: params,
  });
}

export async function fakeAccountLogout() {
  return request(`api/access/logout`, {
    method: 'POST',
  });
}

export async function fakeAccessAuth() {
  return request('api/access/auth', {
    method: 'POST',
  });
}

export async function fakeAccessGrant() {
  return request('api/access/grant', {
    method: 'POST',
  });
}

export async function crudRequest(apiUrl, params, config) {
  return request(apiUrl, {
    method: 'POST',
    body: params,
    reqType: 'json',
    ...config,
  });
}

export async function crudRequestGet(apiUrl, config) {
  return request(apiUrl, {
    method: 'GET',
    ...config,
  });
}

/**
 * 分时段进出货量查询（日实时）
 * @param {Object} params { statisticalDate: 'yyyy-MM-dd', siteCode: string, siteName?: string }
 */
export async function selectInOutVolumeTimeSlot(params, config) {
  return request('/api/route/selectInOutVolumeTimeSlot', {
    method: 'POST',
    body: params,
    reqType: 'json',
    ...config,
  });
}

/**
 * 计划到达/出发货量分时段查询（事后分析，归属时间=计划离港/进港）
 * @param {Object} params { statisticalDate: 'yyyy-MM-dd', siteCode: string, siteName?: string }
 */
export async function selectInOutVolumeTimeSlotPlan(params, config) {
  return request('/api/route/selectInOutVolumeTimeSlotPlan', {
    method: 'POST',
    body: params,
    reqType: 'json',
    ...config,
  });
}

export async function crudRequest2(params, config) {
  return request('/api/route/volumes', {
    method: 'POST',
    body: params,
    reqType: 'json',
    ...config,
  });
}

export async function getSitePlan(params, config) {
  return request('/api/route/getSitePlan', {
    method: 'POST',
    body: params,
    reqType: 'json',
    ...config,
  });
}

export async function crudRequest3(params, config) {
  return request('/api/route/volumes2', {
    method: 'POST',
    body: params,
    reqType: 'json',
    ...config,
  });
}

// 省区运力 按月
export async function provinceAreaMonthVolumes(params, config) {
  return request('/api/route/provinceAreaMonthVolumes', {
    method: 'POST',
    body: params,
    reqType: 'json',
    ...config,
  });
}

// 省区运力 按天
export async function provinceAreaPeriodVolumes(params, config) {
  return request('/api/route/provinceAreaPeriodVolumes', {
    method: 'POST',
    body: params,
    reqType: 'json',
    ...config,
  });
}

// 车辆信息 在途
export async function getWayCars(params) {
  return request('/api/route/shipment/getWayCars', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'forecast'
  });
}

// 车辆信息 在装&待发
export async function getPlanDepartureCarListApi(params) {
  return request('/api/route/shipment/getPlanDepartureCarList', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'forecast'
  });
}

export async function getArriveTime(params) {
  return request('/api/tms/getArriveTime', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'interface',
  });
}

export async function getArriveTimeBatch(params) {
  return request('/api/route/shipment/getArriveTimeBatch', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'interface'
  });
}

// 已到达
export async function getActualArrivalCars(params) {
  return request('/api/route/shipment/getActualArrivalCars', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'forecast'
  });
}

// 已发出
export async function getActualDepartureCars(params) {
  return request('/api/route/shipment/getActualDepartureCars', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'forecast'
  });
}

// 计划到达
export async function getPlanArrivalCars(params) {
  return request('/api/route/shipment/getPlanArrivalCars', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'forecast'
  });
}

// 计划发出
export async function getPlanDepartureCars(params) {
  return request('/api/route/shipment/getPlanDepartureCars', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'forecast'
  });
}

// 获取省区
// 字典未提供一次省区
export async function GetProvince(params) {
  const data = await request('/api/station/organization/selectProvinceAreaTree', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'mdp-station-organization',
  });
  if (data && data.code === 1) {
    data.data &&
      data.data.map((item) => {
        delete item.children;
      });
    return data.data;
  } else {
    return [];
  }
}

// 基础信息查询汇总
// 网点信息查询
export async function GetBasicSite(params) {
  const data = await request(
    `/api/search/site?searchType=${params.searchType}&value=${params.value}`,
    {
      method: 'get',
      reqType: 'json',
      // module: 'interface'
    },
  );
  if (data && data.code === 1) {
    return data.data;
  } else {
    return undefined;
  }
}

// maxINfo 天象交接单查询详情
export async function GetMaxInfo(params) {
  console.log('params', params);
  const data = await request(`/api/v1/track/receipt/info?deliveryNo=${params.deliveryNo}`, {
    method: 'get',
    reqType: 'json',
    module: 'maxcenterbusi',
  });
  if (data && data.code === 1) {
    return data.data;
  } else {
    return undefined;
  }
}

// 任务号车辆信息查询
export async function GetBasicTaskNo(params) {
  const data = await request(`/api/route/shipment/getTaskInfo`, {
    method: 'POST',
    reqType: 'json',
    body: { params: params.taskNo },
    // module: 'interface'
  });
  if (data && data.code === 1) {
    return data.data;
  } else {
    return undefined;
  }
}

// 网点打卡时间信息查询
export async function GetBasicClock(params) {
  const data = await request(
    `/api/search/clock?clockType=${params.clockType}&name=${params.name}`,
    {
      method: 'POST',
      reqType: 'json',
      // module: 'interface'
    },
  );
  if (data && data.code === 1) {
    return data.data;
  } else {
    return [];
  }
}

// 网点签收率信息查询
export async function GetBasicSign(params) {
  const data = await request(`/api/search/sign?name=${params.name}`, {
    method: 'get',
    reqType: 'json',
    // module: 'interface'
  });
  if (data && data.code === 1) {
    return data.data;
  } else {
    return undefined;
  }
}

// 路由信息查询
export async function GetBasicRoute(params) {
  const data = await request(`/api/search/route`, {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'interface'
  });
  if (data && data.code === 1) {
    return data.data;
  } else {
    return undefined;
  }
}

// 计划全程走货路径信息查询
export async function GetBasicPath(params) {
  const data = await request(`/api/search/path`, {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'interface'
  });
  if (data && data.code === 1) {
    return data.data;
  } else {
    return [];
  }
}

// 查询任务号
export async function GetBasicDelivery(params) {
  const data = await request(`/api/noencrypt/delivery/info?deliveryNo=${params.deliveryNo}`, {
    method: 'get',
    reqType: 'json',
    module: 'maxcenter',
    // module: 'interface'
  });
  if (data && data.code === 200) {
    return data.data;
  } else {
    return undefined;
  }
}

// 车线信息查询
export async function GetSection(params) {
  const data = await request(
    `/api/search/section?beginCenterName=${params.beginCenterName}&endCenterName=${params.endCenterName}&type=${params.type}`,
    {
      method: 'get',
    },
  );
  if (data && data.code === 1) {
    return data.data;
  } else {
    return undefined;
  }
}

export async function filedownLoad(params) {
  const authCode = sessionStorage.getItem('x-auth');
  let filesUrl = `/api/fileSystem/download/${params.fileId}?x-auth=${authCode}`;
  let fetchOption = {
    method: 'DOWNLOAD_EXPORT',
    module: 'file-system',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'x-auth': authCode,
    },
  };
  request(`${filesUrl}`, fetchOption)
    .then((res) => {})
    .catch((err) => message.warn(err));
}

export async function filedownLoad_url(apiUrl, params, config) {
  let urlParam = '';
  const auth = sessionStorage.getItem('x-auth');
  if (auth) {
    params['x-auth'] = auth;
  }
  Object.keys(params).forEach((key) => (urlParam += `${key}=${params[key]}&`));
  urlParam = urlParam.replace(/&*.$/, '').replace(/^.*\?/, '');

  request(`${apiUrl}?${urlParam}`, {
    reqType: 'json',
    ...config,
  });
}

// 缓存信息查询
export async function getRedis(params) {
  return request(`/api/search/redis?redisKey=${params.redisKey}`, {
    method: 'get',
    // body: params,
    reqType: 'json',
    // module: 'interface',
  });
}

// 计划全程走货路径信息查询
export async function getPathTest(params) {
  const data = await request(`/api/search/pathTest`, {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'interface'
  });
  if (data && data.code === 1) {
    return data.data;
  } else {
    return [];
  }
}

//未按路由走货看板  三个接口
export async function getCountry(params) {
  return request('/api/deliveryDisaccord/country', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}
export async function getProvince(params) {
  return request('/api/deliveryDisaccord/province', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}
export async function getProduct(params) {
  return request('/api/deliveryDisaccord/product', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}

export async function getDeliveryReceiptMessage(params) {
  return request('/api/route/hbase/getDeliveryReceiptMessage', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}

/**
 * 公共查询
 * @param {string} apiUrl 请求api地址
 * @param {Object<string, string | number>} params 请求参数，JSON对象
 * @param {RequestOption} config 请求配置，例如请求头配置
 * @returns 响应结果
 */
export async function publicRequest(apiUrl, params, config) {
  return request(apiUrl, {
    method: 'POST',
    body: params,
    reqType: 'json',
    ...config,
  });
}

// 汇总
export async function getCarCount(params) {
  return request('/api/route/carsMonitor/getCarCount', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'forecast'
  });
}

export async function selectByCodes(params) {
  return request('/api/station/detail/selectByCodes', {
    method: 'POST',
    body: params,
    module: 'mdp-station-detail',
    reqType: 'json',
  });
}

export const selectListsByKey = (params) => {
  return request(`/api/station/keyword/selectListsByKey`, {
    method: 'POST',
    body: params,
    reqType: 'json',
    module: 'mdp-station-keyword',
  });
};

export const selectListsByKeyPro = (url = '/api/station/keyword/selectByKey', params) => {
  return request(url, {
    method: 'POST',
    body: params,
    reqType: 'format',
    // module: 'mdp-station-keyword',
  });
};

export const selectFlowDirectionQuYu = (params) => {
  return request(`/api/route/selectFlowDirectionQuYu`, {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'mdp-station-keyword',
  });
};

// 获取分拨信息
export const selectAllocateYu = (params) => {
  return request(`/api/station/keyword/selectByKey`, {
    method: 'POST',
    body: params,
    module: 'mdp-station-keyword',
  });
};

// 枚举
export async function getEnumDict(params) {
  return request('/api/basicPublic/selectDictionaryByCode', {
    method: 'POST',
    body: params,
    mergeModuleName: 'tdcs/basic',
    reqType: 'json',
  });
}

// 区域数据字典（大流行区域：中西/华北/华南/华东），经 tdcs/basic 网关转发
export async function selectFlowDirectionPianQu() {
  return request('/api/basicPublic/selectFlowDirectionPianQu', {
    method: 'POST',
    mergeModuleName: 'tdcs/basic',
    reqType: 'json',
  });
}

// 获取车辆监控在装-在库(T/F)的数据
export async function getInventory(params) {
  return request('/api/route/inventory', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}

// 获取车辆监控在装-在库明细数据
export async function getInventoryDetail(params) {
  return request('/api/route/inventoryDetail', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}
